import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
};

export const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setPageChange: (state, action) => {
      state.page = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setPageChange } = tableSlice.actions;

export default tableSlice.reducer;
